import { ChatUserAndToken } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

export function useChatAuthUser(
  isLoggedIn: boolean,
  options?: UseQueryOptions<ChatUserAndToken>
) {
  return useQuery({
    queryKey: ["chat-auth-user"],
    queryFn: async () => {
      if (!isLoggedIn) {
        return {} as ChatUserAndToken;
      }
      return {} as ChatUserAndToken;
    },
    ...options,
  });
}
